<template>
  <div class="p_allcustom_content">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">查询内容</div>
            <el-input v-model="listQuery.SurveyName" placeholder="" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
          </div>
          <div class="screenInput">
            <div class="flname">查询时间</div>
            <el-date-picker @change="timeChange" size="small" v-model="listQuery.times" value-format="yyyy-MM-dd" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" />
          </div>
          <div class="screenInput">
            <div class="flname">状态</div>
            <el-select ref="mySelected" v-model="listQuery.Progress" class="s_sel_top" filterable clearable size="small" placeholder="" @change="searchHandle">
              <el-option label="已完成" :value="2" />
              <el-option label="失败" :value="3" />
              <el-option label="待授权" :value="4" />
              <el-option label="全部" value="" />
            </el-select>
          </div>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="更多检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">更多<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen==-1" type="success" size="small" @click="searchHandle">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="cus_drop_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form1">
          <el-form-item label="身份证号:" label-width="83px">
            <el-input v-model="listQuery.SurveyIDCARD" size="small" clearable style="width:200px" />
          </el-form-item>
          <el-form-item label="查询项目:" label-width="74px">
            <el-input v-model="listQuery.ProductName" size="small" clearable style="width:200px" />
          </el-form-item>
          <el-form-item label="操作人员:" label-width="83px">
            <el-input v-model="listQuery.UserName" size="small" clearable style="width:200px" />
          </el-form-item>
          <el-form-item label="报告编号:" label-width="83px">
            <el-input v-model="listQuery.OrderId" size="small" clearable style="width:200px" />
          </el-form-item>
          <el-form-item label="客户分类:" label-width="74px">
            <el-select v-model="listQuery.BusiType" size="small" placeholder="" style="width:200px">
              <el-option label="闪查客户管理" :value="'1'" />
              <el-option label="内部项目闪查管理" :value="'2'" />
            </el-select>
          </el-form-item>
          <el-form-item label="闪查客户:" label-width="83px" v-if="listQuery.BusiType == '1'">
            <el-select v-model="listQuery.BusiId" size="small" placeholder="" clearable filterable style="width:200px">
              <el-option v-for="(item, index) in backList" :key="index + 'b'" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="内部项目:" label-width="83px" v-if="listQuery.BusiType == '2'">
            <el-select v-model="listQuery.BusiId" size="small" placeholder="" clearable filterable style="width:200px">
              <el-option v-for="(item, index) in internalList" :key="index + 'w'" :label="item.StrCustShortName" :value="item.Projectid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="风险:" label-width="83px">
            <el-select v-model="listQuery.IsRisk" filterable clearable size="small" placeholder="" style="width:200px">
              <el-option label="有风险" :value="1"></el-option>
              <el-option label="无风险" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle">清空</el-button>
        <el-button size="small" type="success" @click="searchHandle">搜索</el-button>
        <el-button size="small" plain @click="closeSearchHandle">关闭</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>客户</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/customList' }">客户列表</el-breadcrumb-item>
          <el-breadcrumb-item>立项客户</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_cusDtl_table" v-if="checkPermission(['bgSet_customer_manage'],permissionLists)">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-if="checkPermission(['bgSet_customer_manage'],permissionLists)" label="闪查客户管理" name="third"></el-tab-pane>
          <el-tab-pane v-if="checkPermission(['bgSet_project_manage'],permissionLists)" label="内部项目闪查管理" name="second"></el-tab-pane>
          <el-tab-pane v-if="checkPermission(['bgSet_product_manage'],permissionLists)" label="闪查产品管理" name="first"></el-tab-pane>
          <el-tab-pane v-if="checkPermission(['bgSet_customer_manage'],permissionLists)" label="客户消费明细" name="four"></el-tab-pane>
          <el-tab-pane v-if="checkPermission(['bgSet_customer_manage'],permissionLists)" label="客户订单" name="five"></el-tab-pane>
          <el-tab-pane v-if="checkPermission(['bgSet_customer_manage'],permissionLists)" label="申请试用列表" name="six"></el-tab-pane>
        </el-tabs>
        <div class="bgset_btn">
          <el-button :loading="exportLoading" type="success" size="small" v-if="!isNull(tableData)" @click="exportHandle">导出数据</el-button>
        </div>
        <el-table ref="multipleTable" v-loading="loading" :data="tableData" style="width: 100%">
          <!-- <el-table-column type="selection" align="center" width="55" label-class-name="com_Selection" /> -->
          <el-table-column prop="CreatedTime" align="center" label="查询时间" min-width="180" fit :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{ scope.row.CreatedTime.replace('T',' ') }}
            </template>
          </el-table-column>
          <el-table-column prop="SurveyName" align="center" label="查询内容" min-width="120" fit :show-overflow-tooltip="true" />
          <el-table-column prop="ProductName" align="center" label="查询项目" min-width="180" fit :show-overflow-tooltip="true" />
          <el-table-column prop="Progress" align="center" label="查询状态" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.Progress == 0 ? '未开始' : scope.row.Progress == 1 ? '查询中' : scope.row.Progress == 2 ? '已完成' : scope.row.Progress == 3 ? '失败' : '待授权' }}
            </template>
          </el-table-column>
          <el-table-column prop="Amount" align="center" label="费用（元）" fit :show-overflow-tooltip="true" min-width="100" />
          <el-table-column prop="IsRiskResult" align="center" label="风险提示" width="100" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              {{ row.IsRiskResult ? row.IsRiskResult=='1' ? '有风险' : '无风险' : ''}}
            </template>
          </el-table-column>
          <el-table-column prop="InquiryAgency" align="center" label="查询机构" min-width="180" fit :show-overflow-tooltip="true" />
          <el-table-column prop="OrderId" align="center" label="报告编号" min-width="200" fit :show-overflow-tooltip="true" />
          <el-table-column prop="UserName" align="center" label="操作人员" min-width="100" fit :show-overflow-tooltip="true" />
          <el-table-column label="查询报告" align="center" width="180" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" :disabled="scope.row.Progress != 2&&scope.row.Progress != 3" @click="reportView(scope.row.Id,scope.row.InquiryAgency)">查看</el-button>
              <el-button type="success" size="mini" :disabled="scope.row.Progress != 2&&scope.row.Progress != 3" @click="expRpt(scope.row.Id)">导出</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="totalCount>0" class="block">
          <el-pagination :current-page.sync="listQuery.pageNum" :page-size="listQuery.pageSize" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount" @current-change="changeBPage" @size-change="handleSizeChange" />
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="visibleReport" width="1050px" title="查看报告">
      <div v-if="hasResult">
        <div v-for="(item,index) in result.orderDetailList" :key="index" style="margin-bottom: 18px;">
          <div class="proName">{{ item.Product }}</div>
          <el-descriptions style="margin: 15px 0 0 15px;width: 1000px;" :column="2" border>
            <el-descriptions-item label="姓名" label-class-name="descriptions_label">{{ result.order.SurveyName }}</el-descriptions-item>
            <el-descriptions-item label="身份证号" label-class-name="descriptions_label">{{ encryption(result.order.SurveyIdcard) }}</el-descriptions-item>
            <el-descriptions-item v-if="item.Product && item.Product.indexOf('手机')>-1" label="手机号码" label-class-name="descriptions_label">{{ encryption(result.order.SurveyTel) }}</el-descriptions-item>
            <el-descriptions-item v-if="item.Product && item.ProductId == 'f31ea4e6-195c-4e99-9b97-44347cd61b0c'" label="银行卡号" label-class-name="descriptions_label">{{ encryption(result.order.Bankcard) }}</el-descriptions-item>
            <el-descriptions-item label="查询结果" label-class-name="descriptions_label">
              <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd61b9c'">
                <p class="lh20">{{ (item.ResultStr&&(item.ResultStr.split('|').length>0))?item.ResultStr.split('|')[0]:'' }}</p>
                <p class="lh20">{{ (item.ResultStr&&(item.ResultStr.split('|').length>1))?item.ResultStr.split('|')[1]:'' }}</p>
              </div>
              <div v-else>{{ item.ResultStr }}</div>
            </el-descriptions-item>
          </el-descriptions>
          <div v-if="judicialLitigation.length>0 && item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd61b9c'" class="personalAdvanced">
            <el-descriptions v-for="(item,index) in judicialLitigation" :key="index" style="margin-left:15px;width: 1000px;" :column="2" border>
              <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.ppre_title }}</el-descriptions-item>
              <el-descriptions-item label="审结时间" label-class-name="descriptions_label">{{ item.ppre_sort_time && item.ppre_sort_time ? getDate(Number(item.ppre_sort_time)) : '' }}</el-descriptions-item>
              <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.ppre_court }}</el-descriptions-item>
              <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.ppre_caseno }}</el-descriptions-item>
              <el-descriptions-item label="案件状态" label-class-name="descriptions_label">{{ item.ppre_case_state }}</el-descriptions-item>
              <el-descriptions-item label="描述" label-class-name="descriptions_label">{{ item.ppre_signal_desc }}</el-descriptions-item>
              <el-descriptions-item label="金额" label-class-name="descriptions_label">{{ item.ppre_execmoney }}</el-descriptions-item>
              <el-descriptions-item label="风险等级" label-class-name="descriptions_label">{{ item.ppre_signal_rating }}</el-descriptions-item>
            </el-descriptions>
          </div>
          <div v-if="judicialLitigationHD.length>0" class="personalAdvanced">
            <div v-for="(item,index) in judicialLitigationHD" :key="index" class="small_item">
              <el-descriptions style="margin-left:15px;width: 1000px;" :column="2" border>
                <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.title }}</el-descriptions-item>
                <el-descriptions-item label="审结时间" label-class-name="descriptions_label">{{ item.sortTimeString}}</el-descriptions-item>
                <el-descriptions-item label="描述" label-class-name="descriptions_label">{{ item.body }}</el-descriptions-item>
                <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.matchRatio }}</el-descriptions-item>
              </el-descriptions>
            </div>
          </div>
          <div v-if="personalAdvanced.length>0 && item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd62b9c'" class="personalAdvanced">
            <el-descriptions v-for="(item,index) in personalAdvanced" :key="index" style="margin-left:15px;width: 1000px;" :column="2" border>
              <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.title }}</el-descriptions-item>
              <el-descriptions-item label="审结时间" label-class-name="descriptions_label">{{ item.sortTimeString }}</el-descriptions-item>
              <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.court }}</el-descriptions-item>
              <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.caseNo }}</el-descriptions-item>
              <el-descriptions-item label="案件状态" label-class-name="descriptions_label">{{ item.caseState }}</el-descriptions-item>
              <el-descriptions-item label="金额" label-class-name="descriptions_label">{{ item.execMoney }}</el-descriptions-item>
              <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.matchRatio }}</el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleReport = false">关 闭</el-button>
        <el-button size="small" type="primary" @click="handleExport">导出报告</el-button>
      </span>
    </el-dialog>
    <div v-if="hasResult && expvivw" class="result_report_box">
      <div ref="pdf" class="result_report" id="pdf_details">
        <div class="logo">
          <img src="../../assets/images/newlogo.png" alt="" id="logo" ref="pdflogo">
        </div>
        <div class="rpTirle">闪 查 报 告</div>
        <div style="margin: 24px 0;">
          <div class="rpContent flex">
            <div class="dot dot1"></div>
            <div class="dot dot2"></div>
            <div class="dot dot3"></div>
            <div style="margin: 0 8px;">报告内容</div>
            <div class="dot dot3"></div>
            <div class="dot dot2"></div>
            <div class="dot dot1"></div>
          </div>
          <div class="tableTitle">报告信息</div>
          <div>
            <el-descriptions style="width: 1000px;" :column="2" border>
              <el-descriptions-item label="候选⼈姓名" label-class-name="descriptions_label">{{ result.order.SurveyName }}</el-descriptions-item>
              <el-descriptions-item label="身份证号" label-class-name="descriptions_label">{{ encryption(result.order.SurveyIdcard) }}</el-descriptions-item>
              <el-descriptions-item label="套餐名称" label-class-name="descriptions_label">自定义</el-descriptions-item>
              <el-descriptions-item label="报告版本" label-class-name="descriptions_label">最终版</el-descriptions-item>
              <el-descriptions-item label="委托方" label-class-name="descriptions_label">{{result.CustomerName}}</el-descriptions-item>
              <el-descriptions-item label="查询结果" label-class-name="descriptions_label">
                <i v-if="result.order.IsRiskResult == '0'" class="el-icon-success res_icon_right"></i>
                <!-- <i v-else class="el-icon-error res_icon_error"></i> -->
                <span v-else>详见下文</span>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
        <div class="resultTitle flex sb">
          <div class="flex">
            <div class="res_title">报告编号：</div>
            <div class="res_content">{{ result.order.OrderId }}</div>
          </div>
          <div class="flex">
            <div class="res_title">查询时间：</div>
            <div class="res_content">{{ result.order.CreatedTime.replace('T',' ') }}</div>
          </div>
        </div>
        <!-- 风险提示 -->
        <div class="mb24">
          <div class="tableTitle">风险提示</div>
          <div class="w1000 c_border">
            <p style="line-height:20px;margin:0;" v-show="!isNull(riskWarningData)&&result.order.IsRiskResult != '0'" v-for="(child,i) in riskWarningData" :key="i+'p'">
              <span>{{i+1}}、候选人存在{{child.Category}}记录，详见下文。</span>
            </p>
            <span style="line-height:20px;margin:0;" v-if="result.order.IsRiskResult == '0'">无风险记录</span>
          </div>
        </div>
        <!-- 报告正文 第二页开始-->
        <div class="mb24">
          <div class="tableTitle">报告正文</div>
          <div class="mb24" v-for="(item,index) in result.orderDetailList" :key="index">
            <!-- 身份风险查询 -->
            <div v-if="item.Category == '身份风险'" class="small_item">
              <div v-if="(item.Sort == 1)&&((!isNull(identityReport))||(!isNull(telReport))||(!isNull(bankReport)))" class="category_title"> {{item.Category}}查询</div>
              <!-- 身份信息验证 -->
              <div v-if="(item.ProductId == 'f11ea4e6-195c-4e99-9b97-44347cd61b0c')&&!isNull(identityReport)" class="mb24 small_item">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <el-table :data="identityReport" border style="width:1001px;">
                  <el-table-column prop="name" align="center" label="查询内容" width="180px" />
                  <el-table-column prop="result" align="center" label="查询结果" width="350" />
                  <el-table-column prop="truth" align="center" label="真实性" width="140">
                    <template slot-scope="{ row }">
                      <span v-if="row.truth == '0'">一致</span>
                      <span v-else-if="isNull(row.truth)"></span>
                      <span v-else>不一致</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="remark" align="center" label="说明" width="330" />
                </el-table>
              </div>
              <!-- 身份,手机号验证 -->
              <div v-if="(item.ProductId == 'f21ea4e6-195c-4e99-9b97-44347cd61b0c')&&!isNull(telReport)" class="mb24 small_item">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <el-table :data="telReport" border style="width:1001px;">
                  <el-table-column prop="name" align="center" label="查询内容" width="180px" />
                  <el-table-column prop="result" align="center" label="查询结果" width="350" />
                  <el-table-column prop="truth" align="center" label="真实性" width="140">
                    <template slot-scope="{ row }">
                      <span v-if="row.truth == '0'">一致</span>
                      <span v-else-if="isNull(row.truth)"></span>
                      <span v-else>不一致</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="remark" align="center" label="说明" width="330" />
                </el-table>
              </div>
              <!-- 身份,手机号验证,银行卡验证 -->
              <div v-if="(item.ProductId == 'f31ea4e6-195c-4e99-9b97-44347cd61b0c')&&!isNull(bankReport)" class="small_item">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <el-table :data="bankReport" border style="width:1001px;">
                  <el-table-column prop="name" align="center" label="查询内容" width="180px" />
                  <el-table-column prop="result" align="center" label="查询结果" width="350" />
                  <el-table-column prop="truth" align="center" label="真实性" width="140">
                    <template slot-scope="{ row }">
                      <span v-if="row.truth == '0'">一致</span>
                      <span v-else-if="isNull(row.truth)"></span>
                      <span v-else>不一致</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="remark" align="center" label="说明" width="330" />
                </el-table>
              </div>
            </div>
            <div v-if="item.Category == '不良风险'" class="small_item mb24">
              <div v-if="item.Sort == 1" class="category_title"> {{item.Category}}查询</div>
              <div class="bg_des_box">
                <div class="bg_des_left">{{ item.Product }}</div>
                <div class="bg_des_right">{{ item.ProductDescri }}</div>
              </div>
              <div class="bg_result_box">
                <div class="bg_result_item">
                  <div class="bg_result_cell bg_result_left">查询结果</div>
                  <div class="bg_result_cell bg_result_right">{{ item.ResultStr }}</div>
                </div>
                <div class="bg_result_item bg_result_item02" v-if="!isNull(item.ResultDetailStr)">
                  <div class="bg_result_cell bg_result_left">不良行为记录</div>
                  <div class="bg_result_cell bg_result_right">{{ item.ResultDetailStr }}</div>
                </div>
              </div>
            </div>
            <div v-if="item.Category == '诉讼风险'" class="small_item">
              <div v-if="item.Sort == 1" class="category_title"> {{item.Category}}查询</div>
              <!-- 司法诉讼 -->
              <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd61b9c'" class="mb24 small_item">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <div class="bg_result_box">
                  <div class="bg_result_item">
                    <div class="bg_result_cell bg_result_left">查询结果</div>
                    <div class="bg_result_cell bg_result_right">
                      <p class="lh20">{{ (item.ResultStr&&(item.ResultStr.split('|').length>0))?item.ResultStr.split('|')[0]:'' }}</p>
                      <p class="lh20">{{ (item.ResultStr&&(item.ResultStr.split('|').length>1))?item.ResultStr.split('|')[1]:'' }}</p>
                    </div>
                  </div>
                  <div class="bg_result_item bg_result_item02" v-if="!isNull(item.ResultDetailStr)">
                    <div class="bg_result_cell bg_result_left">具体结果</div>
                    <div class="bg_result_cell bg_result_right">{{ item.ResultDetailStr }}
                    </div>
                  </div>
                </div>
                <div v-if="judicialLitigation.length>0" class="personalAdvanced">
                  <el-descriptions style="width: 1000px;" :column="2" border>
                    <el-descriptions-item label="信息类型" label-class-name="descriptions_label">执行公告维度</el-descriptions-item>
                  </el-descriptions>
                  <div v-for="(item,index) in judicialLitigation" :key="index" class="small_item">
                    <el-descriptions style="width: 1000px;" :column="2" border>
                      <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.ppre_title }}</el-descriptions-item>
                      <el-descriptions-item label="审结时间" label-class-name="descriptions_label">{{ item.ppre_sort_time && item.ppre_sort_time ? getDate(Number(item.ppre_sort_time)) : ''}}</el-descriptions-item>
                      <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.ppre_court }}</el-descriptions-item>
                      <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.ppre_caseno }}</el-descriptions-item>
                      <el-descriptions-item label="案件状态" label-class-name="descriptions_label">{{ item.ppre_case_state }}</el-descriptions-item>
                      <el-descriptions-item label="描述" label-class-name="descriptions_label">{{ item.ppre_signal_desc }}</el-descriptions-item>
                      <el-descriptions-item label="金额" label-class-name="descriptions_label">{{ item.ppre_execmoney }}</el-descriptions-item>
                      <el-descriptions-item label="风险等级" label-class-name="descriptions_label">{{ item.ppre_signal_rating }}</el-descriptions-item>
                    </el-descriptions>
                  </div>
                </div>
                <div v-if="caseProcessData.length>0" class="personalAdvanced">
                  <el-descriptions style="width: 1000px;" :column="2" border>
                    <el-descriptions-item label="信息类型" label-class-name="descriptions_label">案件流程维度</el-descriptions-item>
                  </el-descriptions>
                  <div v-for="(item,index) in caseProcessData" :key="index" class="small_item">
                    <el-descriptions style="width: 1000px;" :column="2" border>
                      <el-descriptions-item label="诉讼标的" label-class-name="descriptions_label">{{ item.ppre_action_object }}</el-descriptions-item>
                      <el-descriptions-item label="案件流程Id" label-class-name="descriptions_label">{{ item.ppre_ajlc_id}}</el-descriptions-item>
                      <el-descriptions-item label="案件状态" label-class-name="descriptions_label">{{ item.ppre_case_state }}</el-descriptions-item>
                      <el-descriptions-item label="正文" label-class-name="descriptions_label">{{ item.ppre_body }}</el-descriptions-item>
                      <el-descriptions-item label="案由" label-class-name="descriptions_label">{{ item.ppre_case_cause }}</el-descriptions-item>
                      <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.ppre_caseno }}</el-descriptions-item>
                      <el-descriptions-item label="代字" label-class-name="descriptions_label">{{ item.ppre_caseno_kword }}</el-descriptions-item>
                      <el-descriptions-item label="法院等级" label-class-name="descriptions_label">
                        <span v-if="item.ppre_court_rank == '4'">基层法院</span>
                        <span v-if="item.ppre_court_rank == '3'">市中院</span>
                        <span v-if="item.ppre_court_rank == '2'">省高院</span>
                        <span v-if="item.ppre_court_rank == '1'">最高院</span>
                      </el-descriptions-item>
                      <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.ppre_court }}</el-descriptions-item>
                      <el-descriptions-item label="法院类型" label-class-name="descriptions_label">{{ item.ppre_court_type }}</el-descriptions-item>
                      <el-descriptions-item label="组织者" label-class-name="descriptions_label">{{ item.ppre_organizer }}</el-descriptions-item>
                      <el-descriptions-item label="诉讼地位" label-class-name="descriptions_label">
                        <span v-if="item.ppre_party_position == 'p'">原告</span>
                        <span v-if="item.ppre_party_position == 'd'">被告</span>
                        <span v-if="item.ppre_party_position == 't'">第三人</span>
                        <span v-if="item.ppre_party_position == 'u'">当事人</span>
                      </el-descriptions-item>
                      <el-descriptions-item label="当事人称号" label-class-name="descriptions_label">{{ item.ppre_party_title }}</el-descriptions-item>
                      <el-descriptions-item label="当事人类型" label-class-name="descriptions_label">{{ item.ppre_party_type }}</el-descriptions-item>
                      <el-descriptions-item label="当事人名称" label-class-name="descriptions_label">{{ item.ppre_party_pname }}</el-descriptions-item>
                      <el-descriptions-item label="信号描述" label-class-name="descriptions_label">{{ item.ppre_signal_desc }}</el-descriptions-item>
                      <el-descriptions-item label="信号等级" label-class-name="descriptions_label">{{ item.ppre_signal_rating }}</el-descriptions-item>
                      <el-descriptions-item label="立案时间" label-class-name="descriptions_label">{{ item.ppre_sort_time }}</el-descriptions-item>
                      <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.ppre_title }}</el-descriptions-item>
                      <el-descriptions-item label="审理状态" label-class-name="descriptions_label">{{ item.ppre_trial_procedures }}</el-descriptions-item>
                      <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.ppre_match_ratio }}</el-descriptions-item>
                    </el-descriptions>
                  </div>
                </div>
                <div v-if="dimJudicialData.length>0" class="personalAdvanced">
                  <el-descriptions style="width: 1000px;" :column="2" border>
                    <el-descriptions-item label="信息类型" label-class-name="descriptions_label">裁判文书维度</el-descriptions-item>
                  </el-descriptions>
                  <el-descriptions style="width: 1000px;" :column="2" border class="small_item" v-for="(tlt,i) in dimJudicialData" :key="i">
                    <!-- <template v-for="(tlt,i) in dimJudicialData"> -->
                    <template v-for="(item,j) in dimJudicialTitleData">
                      <el-descriptions-item v-if="tlt[item.lableId]&&tlt[item.lableId]!=-1" :key="j" :label="item.lablename" label-class-name="descriptions_label">
                        <span v-if="item.lableId == 'ppre_party_position'">
                          <span v-if="tlt[item.lableId] == 'p'">原告</span>
                          <span v-if="tlt[item.lableId] == 'd'">被告</span>
                          <span v-if="tlt[item.lableId] == 't'">第三人</span>
                          <span v-if="tlt[item.lableId] == 'u'">当事人</span>
                        </span>
                        <span v-if="item.lableId == 'ppre_court_rank'">
                          <span v-if="tlt.ppre_court_rank == '4'">基层法院</span>
                          <span v-if="tlt.ppre_court_rank == '3'">市中院</span>
                          <span v-if="tlt.ppre_court_rank == '2'">省高院</span>
                          <span v-if="tlt.ppre_court_rank == '1'">最高院</span>
                        </span>
                        <span v-if="tlt[item.lableId]&&(item.lablename == '审结时间')&&(item.lableId != 'ppre_party_position')&&(item.lableId != 'ppre_court_rank')&&tlt[item.lableId]!=-1">{{getYMDHMS(Number(tlt[item.lableId]))}}</span>
                        <span v-if="tlt[item.lableId]&&(item.lablename != '审结时间')&&(item.lableId != 'ppre_party_position')&&(item.lableId != 'ppre_court_rank')&&tlt[item.lableId]!=-1">{{ tlt[item.lableId]?tlt[item.lableId]:'' }}</span>
                      </el-descriptions-item>
                    </template>
                    <!-- </template> -->
                  </el-descriptions>
                </div>
                <div v-if="courtDimData.length>0" class="personalAdvanced">
                  <el-descriptions style="width: 1000px;" :column="2" border>
                    <el-descriptions-item label="信息类型" label-class-name="descriptions_label">法院公告维度</el-descriptions-item>
                  </el-descriptions>
                  <div v-for="(item,index) in courtDimData" :key="index" class="small_item">
                    <el-descriptions style="width: 1000px;" :column="2" border>
                      <el-descriptions-item label="正文" label-class-name="descriptions_label">{{ item.ppre_body }}</el-descriptions-item>
                      <el-descriptions-item label="案由" label-class-name="descriptions_label">{{ item.ppre_case_cause}}</el-descriptions-item>
                      <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.ppre_caseno }}</el-descriptions-item>
                      <el-descriptions-item label="代字" label-class-name="descriptions_label">{{ item.ppre_caseno_kword }}</el-descriptions-item>
                      <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.ppre_court }}</el-descriptions-item>
                      <el-descriptions-item label="法院等级" label-class-name="descriptions_label">
                        <span v-if="item.ppre_court_rank == '4'">基层法院</span>
                        <span v-if="item.ppre_court_rank == '3'">市中院</span>
                        <span v-if="item.ppre_court_rank == '2'">省高院</span>
                        <span v-if="item.ppre_court_rank == '1'">最高院</span>
                      </el-descriptions-item>
                      <el-descriptions-item label="法院类型" label-class-name="descriptions_label">{{ item.ppre_court_type }}</el-descriptions-item>
                      <el-descriptions-item label="公告类型" label-class-name="descriptions_label">{{ item.ppre_gg_type }}</el-descriptions-item>
                      <el-descriptions-item label="版面" label-class-name="descriptions_label">{{ item.ppre_layout }}</el-descriptions-item>
                      <el-descriptions-item label="诉讼地位" label-class-name="descriptions_label">
                        <span v-if="item.ppre_party_position == 'p'">原告</span>
                        <span v-if="item.ppre_party_position == 'd'">被告</span>
                        <span v-if="item.ppre_party_position == 't'">第三人</span>
                        <span v-if="item.ppre_party_position == 'u'">当事人</span>
                      </el-descriptions-item>
                      <el-descriptions-item label="当事人称号" label-class-name="descriptions_label">{{ item.ppre_party_title }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_party_type != -1" label="当事人类型" label-class-name="descriptions_label">{{ item.ppre_party_type }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_party_pname != -1" label="当事人名称" label-class-name="descriptions_label">{{ item.ppre_party_pname }}</el-descriptions-item>
                      <el-descriptions-item label="信号描述" label-class-name="descriptions_label">{{ item.ppre_signal_desc }}</el-descriptions-item>
                      <el-descriptions-item label="信号等级" label-class-name="descriptions_label">{{ item.ppre_signal_rating }}</el-descriptions-item>
                      <el-descriptions-item label="发布时间" label-class-name="descriptions_label">{{ item.ppre_post_time }}</el-descriptions-item>
                      <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.ppre_title }}</el-descriptions-item>
                      <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.ppre_match_ratio }}</el-descriptions-item>
                    </el-descriptions>
                  </div>
                </div>
                <div v-if="openDimData.length>0" class="personalAdvanced">
                  <el-descriptions style="width: 1000px;" :column="2" border>
                    <el-descriptions-item label="信息类型" label-class-name="descriptions_label">开庭公告维度</el-descriptions-item>
                  </el-descriptions>
                  <div v-for="(item,index) in openDimData" :key="index" class="small_item">
                    <el-descriptions style="width: 1000px;" :column="2" border>
                      <el-descriptions-item label="正文" label-class-name="descriptions_label">{{ item.ppre_body }}</el-descriptions-item>
                      <el-descriptions-item label="案由" label-class-name="descriptions_label">{{ item.ppre_case_cause}}</el-descriptions-item>
                      <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.ppre_caseno }}</el-descriptions-item>
                      <el-descriptions-item label="代字" label-class-name="descriptions_label">{{ item.ppre_caseno_kword }}</el-descriptions-item>
                      <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.ppre_court }}</el-descriptions-item>
                      <el-descriptions-item label="法院等级" label-class-name="descriptions_label">
                        <span v-if="item.ppre_court_rank == '4'">基层法院</span>
                        <span v-if="item.ppre_court_rank == '3'">市中院</span>
                        <span v-if="item.ppre_court_rank == '2'">省高院</span>
                        <span v-if="item.ppre_court_rank == '1'">最高院</span>
                      </el-descriptions-item>
                      <el-descriptions-item label="法院类型" label-class-name="descriptions_label">{{ item.ppre_court_type }}</el-descriptions-item>
                      <el-descriptions-item label="法官" label-class-name="descriptions_label">{{ item.ppre_judge }}</el-descriptions-item>
                      <el-descriptions-item label="组织者" label-class-name="descriptions_label">{{ item.ppre_organizer }}</el-descriptions-item>
                      <el-descriptions-item label="诉讼地位" label-class-name="descriptions_label">
                        <span v-if="item.ppre_party_position == 'p'">原告</span>
                        <span v-if="item.ppre_party_position == 'd'">被告</span>
                        <span v-if="item.ppre_party_position == 't'">第三人</span>
                        <span v-if="item.ppre_party_position == 'u'">当事人</span>
                      </el-descriptions-item>
                      <el-descriptions-item label="当事人称号" label-class-name="descriptions_label">{{ item.ppre_party_title }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_party_type != -1" label="当事人类型" label-class-name="descriptions_label">{{ item.ppre_party_type }}</el-descriptions-item>
                      <el-descriptions-item label="当事人名称" label-class-name="descriptions_label">{{ item.ppre_party_pname }}</el-descriptions-item>
                      <el-descriptions-item label="信号描述" label-class-name="descriptions_label">{{ item.ppre_signal_desc }}</el-descriptions-item>
                      <el-descriptions-item label="信号等级" label-class-name="descriptions_label">{{ item.ppre_signal_rating }}</el-descriptions-item>
                      <el-descriptions-item label="开庭时间" label-class-name="descriptions_label">{{ item.ppre_court_time }}</el-descriptions-item>
                      <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.ppre_title }}</el-descriptions-item>
                      <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.ppre_match_ratio }}</el-descriptions-item>
                    </el-descriptions>
                  </div>
                </div>
                <div v-if="exposureTableData.length>0" class="personalAdvanced">
                  <el-descriptions style="width: 1000px;" :column="2" border>
                    <el-descriptions-item label="信息类型" label-class-name="descriptions_label">曝光台</el-descriptions-item>
                  </el-descriptions>
                  <div v-for="(item,index) in exposureTableData" :key="index" class="small_item">
                    <el-descriptions style="width: 1000px;" :column="2" border>
                      <el-descriptions-item label="地址" label-class-name="descriptions_label">{{ item.ppre_address }}</el-descriptions-item>
                      <el-descriptions-item label="曝光台ID" label-class-name="descriptions_label">{{ item.ppre_exposure_id }}</el-descriptions-item>
                      <el-descriptions-item label="正文" label-class-name="descriptions_label">{{ item.ppre_body }}</el-descriptions-item>
                      <el-descriptions-item label="案由" label-class-name="descriptions_label">{{ item.ppre_case_cause}}</el-descriptions-item>
                      <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.ppre_caseno }}</el-descriptions-item>
                      <el-descriptions-item label="代字" label-class-name="descriptions_label">{{ item.ppre_caseno_kword }}</el-descriptions-item>
                      <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.ppre_court }}</el-descriptions-item>
                      <el-descriptions-item label="法院等级" label-class-name="descriptions_label">
                        <span v-if="item.ppre_court_rank == '4'">基层法院</span>
                        <span v-if="item.ppre_court_rank == '3'">市中院</span>
                        <span v-if="item.ppre_court_rank == '2'">省高院</span>
                        <span v-if="item.ppre_court_rank == '1'">最高院</span>
                      </el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_court_type != -1" label="法院类型" label-class-name="descriptions_label">{{ item.ppre_court_type }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_execmoney != -1" label="标的金额" label-class-name="descriptions_label">{{ item.ppre_execmoney }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_idcard_no != -1" label="证件号码" label-class-name="descriptions_label">{{ item.ppre_idcard_no }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_party_type != -1" label="当事人类型" label-class-name="descriptions_label">{{ item.ppre_party_type }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_party_pname != -1" label="当事人名称" label-class-name="descriptions_label">{{ item.ppre_party_pname }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_proposer != -1" label="申请人" label-class-name="descriptions_label">{{ item.ppre_proposer }}</el-descriptions-item>
                      <el-descriptions-item label="信号描述" label-class-name="descriptions_label">{{ item.ppre_signal_desc }}</el-descriptions-item>
                      <el-descriptions-item label="信号等级" label-class-name="descriptions_label">{{ item.ppre_signal_rating }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_sort_time != -1" label="立案时间" label-class-name="descriptions_label">{{ item.ppre_sort_time }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_title != -1" label="标题" label-class-name="descriptions_label">{{ item.ppre_title }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_yiju != -1" label="依据" label-class-name="descriptions_label">{{ item.ppre_yiju }}</el-descriptions-item>
                      <el-descriptions-item label="依据案号" label-class-name="descriptions_label">{{ item.ppre_yj_code }}</el-descriptions-item>
                      <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.ppre_match_ratio }}</el-descriptions-item>
                      <el-descriptions-item label="下架标识" label-class-name="descriptions_label">{{ item.ppre_sign }}</el-descriptions-item>
                    </el-descriptions>
                  </div>
                </div>
                <div v-if="dishonestInfoData.length>0" class="personalAdvanced">
                  <el-descriptions style="width: 1000px;" :column="2" border>
                    <el-descriptions-item label="信息类型" label-class-name="descriptions_label">失信信息维度</el-descriptions-item>
                  </el-descriptions>
                  <div v-for="(item,index) in dishonestInfoData" :key="index" class="small_item">
                    <el-descriptions style="width: 1000px;" :column="2" border>
                      <el-descriptions-item label="年龄" label-class-name="descriptions_label">{{ item.ppre_age }}</el-descriptions-item>
                      <el-descriptions-item label="正文" label-class-name="descriptions_label">{{ item.ppre_body }}</el-descriptions-item>
                      <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.ppre_caseno }}</el-descriptions-item>
                      <el-descriptions-item label="代字" label-class-name="descriptions_label">{{ item.ppre_caseno_kword }}</el-descriptions-item>
                      <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.ppre_court }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_idcard_no != -1" label="证件号码" label-class-name="descriptions_label">{{ item.ppre_idcard_no }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_jtqx != -1" label="具体情形" label-class-name="descriptions_label">{{ item.ppre_jtqx }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_lxqk != -1" label="履行情况" label-class-name="descriptions_label">{{ item.ppre_lxqk }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_money != -1" label="金额" label-class-name="descriptions_label">{{ item.ppre_money }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_party_type != -1" label="当事人类型" label-class-name="descriptions_label">{{ item.ppre_party_type }}</el-descriptions-item>
                      <el-descriptions-item label="当事人名称" label-class-name="descriptions_label">{{ item.ppre_party_pname }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_post_time != -1" label="发布时间" label-class-name="descriptions_label">{{ item.ppre_post_time }}</el-descriptions-item>
                      <el-descriptions-item label="省份" label-class-name="descriptions_label">{{ item.ppre_province }}</el-descriptions-item>
                      <el-descriptions-item label="失信公告id" label-class-name="descriptions_label">{{ item.ppre_dishonesty_id }}</el-descriptions-item>
                      <el-descriptions-item label="信号描述" label-class-name="descriptions_label">{{ item.ppre_signal_desc }}</el-descriptions-item>
                      <el-descriptions-item label="信号等级" label-class-name="descriptions_label">{{ item.ppre_signal_rating }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_sort_time != -1" label="立案时间" label-class-name="descriptions_label">{{ item.ppre_sort_time }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_yiwu != -1" label="义务" label-class-name="descriptions_label">{{ item.ppre_yiwu }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_yj_code != -1" label="依据案号" label-class-name="descriptions_label">{{ item.ppre_yj_code }}</el-descriptions-item>
                      <el-descriptions-item v-if="item.ppre_yjdw != -1" label="依据单位" label-class-name="descriptions_label">{{ item.ppre_yjdw }}</el-descriptions-item>
                      <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.ppre_match_ratio }}</el-descriptions-item>
                      <el-descriptions-item label="下架标识" label-class-name="descriptions_label">{{ item.ppre_sign }}</el-descriptions-item>
                    </el-descriptions>
                  </div>
                </div>

                <div v-if="judicialLitigationHD.length>0" class="personalAdvanced">
                  <div v-for="(item,index) in judicialLitigationHD" :key="index" class="small_item">
                    <el-descriptions style="width: 1000px;" :column="2" border>
                      <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.title }}</el-descriptions-item>
                      <el-descriptions-item label="审结时间" label-class-name="descriptions_label">{{ item.sortTimeString}}</el-descriptions-item>
                      <el-descriptions-item label="描述" label-class-name="descriptions_label">{{ item.body }}</el-descriptions-item>
                      <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.matchRatio }}</el-descriptions-item>
                    </el-descriptions>
                  </div>
                </div>
              </div>
              <!-- 法院被执行人 (限高信息) -->
              <div v-if="item.ProductId=='F32ea4e6-195c-4e99-9b97-44347cd61b0c'" class="mb24 small_item">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <div class="bg_result_box">
                  <div class="bg_result_item">
                    <div class="bg_result_cell bg_result_left">查询结果</div>
                    <div class="bg_result_cell bg_result_right">{{ item.ResultStr }}</div>
                  </div>
                </div>
                <!-- 有命中 -->
                <div v-if="!isNull(item.returnSetList1)" class="personalAdvanced">
                  <el-descriptions style="width: 1000px;" :column="2" border>
                    <template v-for="(eleTitle,i) in heightLimitTitleData">
                      <template v-for="(ele) in item.returnSetList1">
                        <el-descriptions-item :key="i" :label="eleTitle.name" label-class-name="descriptions_label" v-if="!isNull(eleTitle.clo3) && !isNull(eleTitle.clo2) && !isNull(ele.hasOwnProperty(eleTitle.clo2)) && (ele[eleTitle.clo2].hasOwnProperty(eleTitle.clo3))">
                          <span class="l_txt">{{ ele[eleTitle.clo2][eleTitle.clo3] }}</span>
                          <span v-if="isNull(eleTitle.clo3)"></span>
                        </el-descriptions-item>
                      </template>
                    </template>
                  </el-descriptions>
                </div>
              </div>
              <!-- 法院信息详情 -->
              <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd62b9c'" class="mb24 small_item">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <div class="bg_result_box">
                  <div class="bg_result_item">
                    <div class="bg_result_cell bg_result_left">查询结果</div>
                    <div class="bg_result_cell bg_result_right">{{ item.ResultStr }}</div>
                  </div>
                </div>
                <!-- 有命中 -->
                <div v-if="personalAdvanced.length>0" class="personalAdvanced">
                  <div v-for="(item,index) in personalAdvanced" :key="index">
                    <el-descriptions style="width: 1000px;" :column="2" border>
                      <el-descriptions-item label="标题" label-class-name="descriptions_label">{{ item.title }}</el-descriptions-item>
                      <el-descriptions-item label="审结时间" label-class-name="descriptions_label">{{ item.sortTimeString }}</el-descriptions-item>
                      <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ item.court }}</el-descriptions-item>
                      <el-descriptions-item label="案号" label-class-name="descriptions_label">{{ item.caseNo }}</el-descriptions-item>
                      <el-descriptions-item label="案件状态" label-class-name="descriptions_label">{{ item.caseState }}</el-descriptions-item>
                      <el-descriptions-item label="金额" label-class-name="descriptions_label">{{ item.execMoney }}</el-descriptions-item>
                      <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ item.matchRatio }}</el-descriptions-item>
                    </el-descriptions>
                  </div>
                </div>
              </div>
              <!-- 法院被执行人详情 -->
              <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b91-44347cd62b9c'" class="mb24 small_item">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <div class="bg_result_box">
                  <div class="bg_result_item">
                    <div class="bg_result_cell bg_result_left">查询结果</div>
                    <div class="bg_result_cell bg_result_right">{{ item.ResultStr }}</div>
                  </div>
                </div>
                <!-- 法院被执行人-高级版有命中 -->
                <div v-if="!isNull(item.returnSetList2)" class="personalAdvanced">
                  <el-descriptions style="width: 1000px;" :column="2" border>
                    <template v-for="(ele,i) in item.returnSetList2">
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="案号" label-class-name="descriptions_label">{{ ele.execut.casenum?ele.execut.casenum:'' }}</el-descriptions-item>
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="下架标识" label-class-name="descriptions_label">{{ ele.execut.sign?ele.execut.sign:'' }}</el-descriptions-item>
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="个人匹配度" label-class-name="descriptions_label">{{ ele.execut.matchRatio?ele.execut.matchRatio:'' }}</el-descriptions-item>
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="法院名称" label-class-name="descriptions_label">{{ ele.execut.court?ele.execut.court:'' }}</el-descriptions-item>
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="五级分类" label-class-name="descriptions_label">{{ ele.execut.eventLevel?ele.execut.eventLevel:'' }}</el-descriptions-item>
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="执行金额" label-class-name="descriptions_label">{{ ele.execut.money?ele.execut.money:'' }}</el-descriptions-item>
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="信号描述" label-class-name="descriptions_label">{{ ele.execut.signalDesc?ele.execut.signalDesc:'' }}</el-descriptions-item>
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="名称" label-class-name="descriptions_label">{{ ele.execut.name?ele.execut.name:'' }}</el-descriptions-item>
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="信号等级" label-class-name="descriptions_label">{{ ele.execut.signalRating?ele.execut.signalRating:'' }}</el-descriptions-item>
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="立案日期" label-class-name="descriptions_label">{{ ele.execut.time?ele.execut.time:'' }}</el-descriptions-item>
                      <el-descriptions-item :key="i" v-if="!isNull(ele.execut)" label="案件状态" label-class-name="descriptions_label">{{ ele.execut.statute?ele.execut.statute:'' }}</el-descriptions-item>
                    </template>
                  </el-descriptions>
                </div>
              </div>
              <!-- 法院裁决文书 -->
              <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b92-44347cd62b9c'" class="mb24 small_item">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <div class="bg_result_box">
                  <div class="bg_result_item">
                    <div class="bg_result_cell bg_result_left">查询结果</div>
                    <div class="bg_result_cell bg_result_right">{{ item.ResultStr }}</div>
                  </div>
                  <div class="bg_result_item bg_result_item02" v-if="!isNull(item.ResultDetailStr)">
                    <div class="bg_result_cell bg_result_left">具体结果</div>
                    <div class="bg_result_cell bg_result_right">{{ item.ResultDetailStr }}</div>
                  </div>
                </div>
                <!--法院裁决文书 有命中 -->
                <div v-if="judicialLitigationHD2.ExecutionJud!=undefined && judicialLitigationHD2.ExecutionJud.length>0" class="personalAdvanced">
                  <div v-for="(j,i) in judicialLitigationHD2.ExecutionJud" :key="i" class="small_item">
                    <el-descriptions style="width: 1000px;" :column="2" border>
                      <el-descriptions-item label="案例类型" label-class-name="descriptions_label">{{ j.caseTypeS }}</el-descriptions-item>
                      <el-descriptions-item label="文书编号" label-class-name="descriptions_label">{{ j.caseNo }}</el-descriptions-item>
                      <el-descriptions-item label="法院" label-class-name="descriptions_label">{{ j.court}}</el-descriptions-item>
                      <el-descriptions-item label="描述" label-class-name="descriptions_label">{{ j.body }}</el-descriptions-item>
                      <el-descriptions-item label="案例原因" label-class-name="descriptions_label">{{ j.caseCause }}</el-descriptions-item>
                      <el-descriptions-item label="裁决结果" label-class-name="descriptions_label">{{ j.judgeResult }}</el-descriptions-item>
                      <el-descriptions-item label="匹配度" label-class-name="descriptions_label">{{ j.matchRatio }}</el-descriptions-item>
                    </el-descriptions>
                  </div>
                </div>
              </div>
              <div v-if="isHasRiskData&&(item.Sort == litigationRisk.length)" class="tips small_item">
                <p>注：</p>
                <p>风险等级：根据诉讼风控规则加工得出，用于识别当事人在案件中的风险等级，分为1-7级，等级越低，风险越高</p>
                <p>匹配度：值越大，表示匹配程度越高。0.4大概率不是本人，0.6-0.7是本人概率较高，0.8-0.9基本确定是本人案件。</p>
              </div>
            </div>
            <div v-if="item.Category == '信用风险'" class="small_item">
              <div v-if="item.Sort == 1" class="category_title"> {{item.Category}}查询</div>
              <!-- 信用风险、风险名单、网贷黑名单 -->
              <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd61b1c'||item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd61b2c'||item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd61b3c'" class="mb24 small_item">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <div class="bg_result_box">
                  <div class="bg_result_item">
                    <div class="bg_result_cell bg_result_left">查询结果</div>
                    <div class="bg_result_cell bg_result_right">{{ item.ResultStr }}</div>
                  </div>
                  <div class="bg_result_item bg_result_item02" v-if="!isNull(item.ResultDetailStr)">
                    <div class="bg_result_cell bg_result_left">具体结果</div>
                    <div class="bg_result_cell bg_result_right">{{ item.ResultDetailStr }}</div>
                  </div>
                </div>
              </div>
              <!-- 逾期风险扫描 -->
              <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b97-44347cd61b4c'" class="mb24 small_item">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <div class="bg_result_box">
                  <div class="bg_result_item">
                    <div class="bg_result_cell bg_result_left">查询结果</div>
                    <div class="bg_result_cell bg_result_right">{{ item.ResultStr }}</div>
                  </div>
                  <div class="bg_result_item bg_result_item02" v-if="!isNull(item.ResultDetailStr)">
                    <div class="bg_result_cell bg_result_left">具体结果</div>
                    <div class="bg_result_cell bg_result_right">{{ item.ResultDetailStr }}</div>
                  </div>
                </div>
                <el-table v-if="!isNull(overdueRiskData)" :data="overdueRiskData" border style="width:1001px;">
                  <el-table-column prop="name" align="center" label="比中项目" width="501" />
                  <el-table-column prop="result" align="center" label="结果" width="500">
                    <template slot-scope="{ row }">
                      <span>{{row.result}}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-if="item.Category == '工作风险'" class="small_item">
              <div v-if="item.Sort == 1" class="category_title"> {{item.Category}}查询</div>
              <!-- 个人工商记录查询 -->
              <div v-if="item.ProductId=='f32ea4e6-195c-4e99-9b97-45347cd61b4c'" class="mb24">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <div class="bg_result_box">
                  <div class="bg_result_item">
                    <div class="bg_result_cell bg_result_left">查询结果</div>
                    <div class="bg_result_cell bg_result_right">
                      <span v-if="item.IsRiskResult == '0'||isNull(item.IsRiskResult)">无风险</span>
                      <span v-else>存在风险</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 企业任职画像 -->
              <div v-if="item.ProductId=='f32ea4e6-196c-4e99-9b97-45347cd61b4c'" class="mb24">
                <div class="bg_des_box">
                  <div class="bg_des_left">{{ '0'+item.Sort+' '+item.Product }}</div>
                  <div class="bg_des_right">{{ item.ProductDescri }}</div>
                </div>
                <div class="bg_result_box">
                  <div class="bg_result_item">
                    <div class="bg_result_cell bg_result_left">查询结果</div>
                    <div class="bg_result_cell bg_result_right">{{ item.ResultStr }}</div>
                  </div>
                  <div class="bg_result_item bg_result_item02" v-if="!isNull(item.ResultDetailStr)">
                    <div class="bg_result_cell bg_result_left">具体结果</div>
                    <div class="bg_result_cell bg_result_right">
                      <p class="pic_txt" v-for="(cur,j) in item.ResultDetailStr.split(';')" :key="j+'o'">{{cur}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 教育风险 -->
            <div v-if="item.Category == '教育风险'&& !isNull(educInfoData)" class="small_item mb24">
              <div v-if="item.Sort == 1" class="category_title"> {{item.Category}}查询</div>
              <div class="bg_des_box">
                <div class="bg_des_left">{{ item.Product }}</div>
                <div class="bg_des_right">{{ item.ProductDescri }}</div>
              </div>
              <el-table v-if="!isNull(educInfoData)" :data="educInfoData" border style="width:1001px;">
                <el-table-column prop="name" align="center" label="查询内容" width="180px" />
                <el-table-column prop="result" align="center" label="查询结果" width="821px">
                  <template slot-scope="{ row }">
                    <!-- 学习形式 -->
                    <span v-if="row.resultType == 'FC'">
                      <span v-if="row.result == 0">其他</span>
                      <span v-if="row.result == 1">全日制</span>
                      <span v-if="row.result == 2">普通全日制</span>
                      <span v-if="row.result == 3">异值</span>
                      <span v-if="row.result == 4">非全日制</span>
                      <span v-if="row.result == 5">脱产</span>
                      <span v-if="row.result == 6">开放教育</span>
                      <span v-if="row.result == 7">业余</span>
                      <span v-if="row.result == 8">函授</span>
                      <span v-if="row.result == 9">夜大学</span>
                    </span>
                    <!-- 学习层次 -->
                    <span v-else-if="row.resultType == 'LC'">
                      <span v-if="row.result == 0">本科</span>
                      <span v-if="row.result == 1">硕士</span>
                      <span v-if="row.result == 2">博士</span>
                      <span v-if="row.result == -1">专科</span>
                      <span v-if="row.result == -2">高中</span>
                      <span v-if="row.result == -3">中专</span>
                      <span v-if="row.result == -4">初中</span>
                      <span v-if="row.result == -5">小学</span>
                      <span v-if="row.result == -6">其他</span>
                    </span>
                    <span v-else>{{row.result}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="small_item">
          <div class="statement">声明：</div>
          <div class="statementContent">授{{result.CustomerName}}的委托，并由授权人 <span style="color: #19bd92;">{{result.order.SurveyName}}</span> 书面授权同意，以降低招聘风险为目的，按照委托方及授权人提供的信息，通过专业闪查流程，进行背景信息核实工作。</div>
          <div class="statementContent">以上信息均通过符合法律法规的途径获得，其信息均为候选人资质、工作背景相关信息掌握机构所提供，由浙江杰博人力资源股份有限公司（以下简称“杰博”）记录整理而成，且不代表“杰博”及公司任何员工的主观意见。</div>
          <div class="statementContent">本报告内容不得向任何第三方透露，仅供委托方参考，“杰博”不承担此报告产生的任何法律责任。</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "@/common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    downloadPDF
  } from "@/utils/pdf.js";
  import JSZip from 'jszip'
  import FileSaver from 'file-saver'
  export default {
    name: "serviceCenter",
    data() {
      return {
        showDropScreen: -1,
        totalCount: 0,
        listQuery: {
          times: [],
          StartTime: "",
          EndTime: "",
          ProductName: '',
          SurveyIDCARD: '',
          InquiryAgency: '',
          BusiId: '',
          BusiType: '',
          SurveyName: '',
          OrderId: '',
          UserName: '',
          roletype: '',
          IsRisk: '',
          IsExport: '', //1导出
          pageNum: 1,
          pageSize: 10
        },
        resProjectList: [],
        InquiryAgency: '', // 公司名称
        pickerOptions: {
          shortcuts: [{
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                picker.$emit('pick', [start, end])
              }
            }
          ]
        },
        tableData: [],
        loading: false,
        visibleReport: false,
        result: {},
        hasResult: false,
        expvivw: false,
        heightTitleData: [], // 法院被执行人—高级版表头
        heightLimitTitleData: [], // 法院被执行人—限高版表头
        multipleTable: [],
        interval: '', // 定时器
        expLoading: false,
        fileArr: [], // 文件列表
        creditRisks: [],
        heightTitleData: [], //法院被执行人详情表头
        educInfoData: [], //学历信息列表
        loanBlacklistData: [], //网贷黑名单
        overdueRiskData: [], //逾期风险
        riskWarningData: [], //风险提示
        dimJudicialTitleData: [], //裁判文书表头
        caseProcessData: [], //案件流程维度
        dimJudicialData: [], //裁判文书表头
        courtDimData: [], //法院公告维度
        openDimData: [], //开庭公告维度
        exposureTableData: [], //曝光台
        dishonestInfoData: [], //失信信息
        litigationRisk: [],
        isHasRiskData: false,
        identityReport: [],
        telReport: [],
        bankReport: [],
        // 按钮权限参数
        butQuery: {
          path: '/bgSet',
          powerEnName: 'product'
        },
        permissionLists: [],
        activeName: 'five',
        exportLoading: false,
        backList: [],
        internalList: [],
        exportQuery: {},
        judicialLitigationHD: [],
        judicialLitigationHD2: [], //百融裁决文书
      }
    },
    created() {
      this.dimJudicialTitleData = [{
          lablename: '出生日期',
          lableId: 'ppre_birthday'
        },
        {
          lablename: '正文',
          lableId: 'ppre_body'
        },
        {
          lablename: '受理费',
          lableId: 'ppre_caf'
        },
        {
          lablename: '案由',
          lableId: 'ppre_case_cause'
        },
        {
          lablename: '案号',
          lableId: 'ppre_caseno'
        },
        {
          lablename: '代字',
          lableId: 'ppre_caseno_kword'
        },
        {
          lablename: '文书类型',
          lableId: 'ppre_case_type'
        },
        {
          lablename: '法院',
          lableId: 'ppre_court'
        },
        {
          lablename: '法院等级',
          lableId: 'ppre_court_rank'
        },
        {
          lablename: '法院类型',
          lableId: 'ppre_court_type'
        },
        {
          lablename: '法官',
          lableId: 'ppre_judge'
        },
        {
          lablename: '判决结果',
          lableId: 'ppre_judge_result'
        },
        {
          lablename: '律师事务所',
          lableId: 'ppre_law_office'
        },
        {
          lablename: '委托律师',
          lableId: 'ppre_lawyer'
        },
        {
          lablename: '判决金额',
          lableId: 'ppre_party_fee'
        },
        {
          lablename: '诉讼地位',
          lableId: 'ppre_party_position'
        },
        {
          lablename: '胜负关系',
          lableId: 'ppre_party_result'
        },
        {
          lablename: '当事人称号',
          lableId: 'ppre_party_title'
        },
        {
          lablename: '当事人类型',
          lableId: 'ppre_party_type'
        },
        {
          lablename: '当事人名称',
          lableId: 'ppre_party_pname'
        },
        {
          lablename: '信号描述',
          lableId: 'ppre_signal_desc'
        },
        {
          lablename: '信号等级',
          lableId: 'ppre_signal_rating'
        },
        {
          lablename: '审结时间',
          lableId: 'ppre_filing_time'
        },
        {
          lablename: '标题',
          lableId: 'ppre_title'
        },
        {
          lablename: '审理状态',
          lableId: 'ppre_trial_procedures'
        },
        {
          lablename: '依据',
          lableId: 'ppre_yiju'
        },
        {
          lablename: '匹配度',
          lableId: 'ppre_match_ratio'
        }
      ]
      this.getButtonPower()
      // this.getbusiIdbyuserId()
      this.getHeightTitlelist(13)
      this.getHeightTitlelist(14)
      this.getResourceJoblist()
      this.getBackData("internal")
      this.getBackData("back")
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let actives = this.$route.query.activeName;
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              if (!that.isNull(actives)) {
                that.activeName = actives
                if (that.activeName == "second") {
                  that.$router.push({
                    path: '/bgSet',
                    query: {
                      activeName: 'second'
                    }
                  })
                } else if (that.activeName == "first") {
                  that.$router.push({
                    path: '/bgSet',
                    query: {
                      activeName: 'first'
                    }
                  })
                } else if (that.activeName == "third") {
                  that.$router.push({
                    path: '/bgSet',
                    query: {
                      activeName: 'third'
                    }
                  })
                } else if (that.activeName == "four") {
                  that.$router.push({
                    path: '/consumerDetails',
                    query: {
                      activeName: 'four'
                    }
                  })
                } else if (that.activeName == "five") {
                  that.getcertorderlist()
                }
              } else {
                if (that.checkPermission(['bgSet_customer_manage'], that.permissionLists)) {
                  that.activeName = 'five'
                  that.getcertorderlist()
                } else if ((!that.checkPermission(['bgSet_customer_manage'], that.permissionLists)) && (that.checkPermission(['bgSet_project_manage'], that.permissionLists))) {
                  that.$router.push({
                    path: '/bgSet',
                    query: {
                      activeName: 'second'
                    }
                  })
                } else if ((!that.checkPermission(['bgSet_customer_manage'], that.permissionLists)) && (!that.checkPermission(['bgSet_project_manage'], that.permissionLists)) && (that.checkPermission(['bgSet_product_manage'], that.permissionLists))) {
                  that.$router.push({
                    path: '/bgSet',
                    query: {
                      activeName: 'first'
                    }
                  })
                }
              }
            } else {
              this.permissionLists = []
              this.activeName = ''
            }
          } else {
            this.permissionLists = []
            this.activeName = ''
          }
        })
      },
      timeChange(val) {
        if (this.isNull(val)) {
          this.listQuery.times = []
          this.listQuery.StartTime = ''
          this.listQuery.EndTime = ''
        }
      },
      //获取闪查产品管理列表
      getBackData(type) {
        let query = {
          pageNum: 1,
          pageSize: 100000000,
          name: ""
        }
        if (type == "internal") {
          xz.getprojectlist(query).then((res) => {
            if (res.status == "ok") {
              this.internalList = res.data.list;
            } else {
              this.internalList = [];
            }
          });
        } else if (type == "back") {
          xz.getcustomer(query).then((res) => {
            if (res.status == "ok") {
              this.backList = res.data.RetList;
            } else {
              this.backList = [];
            }
          });
        }
      },
      getYMDHMS(timestamp) {
        let time = new Date(timestamp)
        let year = time.getFullYear()
        let month = time.getMonth() + 1
        let date = time.getDate()
        let hours = time.getHours()
        let minute = time.getMinutes()
        let second = time.getSeconds()

        if (month < 10) {
          month = '0' + month
        }
        if (date < 10) {
          date = '0' + date
        }
        if (hours < 10) {
          hours = '0' + hours
        }
        if (minute < 10) {
          minute = '0' + minute
        }
        if (second < 10) {
          second = '0' + second
        }
        return year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second
      },
      // 筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1
        }
      },
      // 关闭筛选
      closeSearchHandle() {
        this.showDropScreen = -1
        this.memberComQuery.strWorkState = '在职'
      },
      // 用户取自己的 BusiIdB,BusiType
      getbusiIdbyuserId() {
        const that = this
        xz.getbusiIdbyuserId().then((res) => {
          // console.log('dd',res)
          if (res.status == 'ok') {
            // that.listQuery.BusiId = res.data.busiId
            // that.listQuery.BusiType = res.data.BusiType
            that.getcertorderlist()
          }
        })
      },
      // 导出
      exportHandle() {
        this.exportQuery = JSON.parse(JSON.stringify(this.listQuery))
        this.exportQuery.pageSize = 1000000
        this.exportQuery.pageNum = 1
        this.exportQuery.IsExport = '1'
        this.exportLoading = true
        xz.getcertorderlist(this.exportQuery).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a")
            aLink.download = '客户订单' + '.xls' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
          } else {
            this.$message({
              message: "导出失败，请稍后再试",
              type: "error"
            })
          }
          this.exportLoading = false
        })
      },
      // 搜索
      searchHandle() {
        if (!this.isNull(this.listQuery.times)) {
          this.listQuery.StartTime = this.listQuery.times[0]
          this.listQuery.EndTime = this.listQuery.times[1]
        }
        this.showDropScreen = -1
        this.getcertorderlist()
      },
      // 清空
      resetHandle() {
        this.listQuery.times = []
        this.listQuery.StartTime = ''
        this.listQuery.EndTime = ''
        this.listQuery = this.$options.data.call(this).listQuery
        // this.listQuery.BusiType = '1'
      },
      // 获取有权限的项目列表和岗位列表
      getResourceJoblist() {
        xz.getresourcechangejoblist({}, localStorage.loginRoletype).then(res => {
          // console.log('项目名称列表', res)
          if (res.status == 'ok') {
            // console.log(99,res)
            this.resProjectList = res.data.retList
            // 项目列表去重
            const obj = {}
            const peon = this.resProjectList.reduce((cur, next) => {
              obj[next.StrprojectName] ? '' : obj[next.StrprojectName] = true && cur.push(next)
              return cur
            }, []) // 设置cur默认类型为数组，并且初始值为空的数组
            this.resProjectList = peon
          }
        })
      },
      // 批量查询表格多选
      handleSelectionChange(val) {
        // console.log('yyy', val)
        this.multipleTable = val
      },
      // 获取法院被执行人取表头" 13代表法院被执行人—高级版，14代表 法院被执行人-限高版
      getHeightTitlelist(type) {
        xz.getbairongExecutionPro(type).then((res) => {
          if (res.status == 'ok') {
            if (type == '13') {
              this.heightTitleData = res.data;
            } else if (type == '14') {
              this.heightLimitTitleData = res.data
            }
          } else {
            if (type == '13') {
              this.heightTitleData = []
            } else if (type == '14') {
              this.heightLimitTitleData = []
            }
          }
        })
      },
      getcertorderlist() {
        this.loading = true
        xz.getcertorderlist(this.listQuery).then((res) => {
          console.log(res)
          if (res.status == 'ok') {
            this.tableData = res.data.RetList
            this.totalCount = res.data.totalCount
          } else {
            this.tableData = []
          }
        })
        this.loading = false
      },
      // 翻页
      changeBPage(val) {
        this.listQuery.pageNum = val
        this.getcertorderlist()
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`)
        this.listQuery.pageNum = 1
        this.listQuery.pageSize = val
        this.getcertorderlist()
      },
      // 加密处理
      encryption(val) {
        if (val.length == 11) {
          const r1 = val.slice(0, 3)
          const r2 = val.slice(val.length - 4, val.length)
          return r1 + '****' + r2
        } else {
          const r1 = val.slice(0, 4)
          const r2 = val.slice(val.length - 4, val.length)
          return r1 + '**********' + r2
        }
      },
      // 获取报告详情
      getRptDetails(Id, type) {
        const that = this
        this.hasResult = false
        xz.getcertorderdetail(Id).then((res) => {
          this.judicialLitigationHD = []
          this.judicialLitigationHD2 = []
          this.judicialLitigation = []
          this.personalAdvanced = []
          this.creditRisks = [];
          this.riskWarningData = []
          this.litigationRisk = []
          that.caseProcessData = []; // 案件流程维度
          that.dimJudicialData = []; // 裁判文书维度
          that.courtDimData = []; // 法院公告维度
          that.openDimData = []; // 开庭公告维度
          that.exposureTableData = []; // 曝光台
          that.dishonestInfoData = []; // 失信信息
          that.overdueRiskData = [];
          that.educInfoData = [];
          if (res.status == 'ok') {
            let copyData = JSON.parse(JSON.stringify(res.data.orderDetailList)) //拷贝
            if (!that.isNull(copyData)) {
              let copy01 = []
              // 排除掉岗位未修改时的数据(异常状态下未修改的不用走终止接口)
              copy01 = copyData.filter(item => {
                return (item.IsRiskResult != 0) && (item.Progress == 2)
              });
              for (let i = 0; i < copy01.length; i++) {
                for (let j = i + 1; j < copy01.length; j++) {
                  if (copy01[i].Category === copy01[j].Category) {
                    copy01.splice(j, 1);
                    j--
                  }
                };
              }
              that.riskWarningData = copy01
            } else {
              that.riskWarningData = []
            }
            res.data.orderDetailList.forEach((element) => {
              if (!that.isNull(element.ThirdPartyReturn)) {
                that.$set(element, "ThirdPartyReturn3", JSON.parse(element.ThirdPartyReturn));
              } else {
                that.$set(element, "ThirdPartyReturn3", '');
              }
              if (element.Category == '诉讼风险') {
                this.litigationRisk.push(element);
              }
              if (element.ProductId == "f11ea4e6-195c-4e99-9b97-44347cd61b0c") {
                this.identityReport = [{
                    name: '身份证号码',
                    result: this.encryption(res.data.order.SurveyIdcard),
                    truth: element.IsRiskResult,
                    remark: ''
                  },
                  {
                    name: '姓名',
                    result: res.data.order.SurveyName,
                    truth: element.IsRiskResult,
                    remark: ''
                  }
                ]
              } else if (element.ProductId == 'f21ea4e6-195c-4e99-9b97-44347cd61b0c') {
                this.telReport = [{
                    name: '身份证号码',
                    result: this.encryption(res.data.order.SurveyIdcard),
                    truth: element.IsRiskResult,
                    remark: ''
                  },
                  {
                    name: '姓名',
                    result: res.data.order.SurveyName,
                    truth: element.IsRiskResult,
                    remark: ''
                  },
                  {
                    name: '手机号码',
                    result: this.encryption(res.data.order.SurveyTel),
                    truth: element.IsRiskResult,
                    remark: ''
                  }
                ]
              } else if (element.ProductId == 'f31ea4e6-195c-4e99-9b97-44347cd61b0c') {
                this.bankReport = [{
                    name: '身份证号码',
                    result: this.encryption(res.data.order.SurveyIdcard),
                    truth: element.IsRiskResult,
                    remark: ''
                  },
                  {
                    name: '姓名',
                    result: res.data.order.SurveyName,
                    truth: element.IsRiskResult,
                    remark: ''
                  },
                  {
                    name: '手机号码',
                    result: this.encryption(res.data.order.SurveyTel),
                    truth: element.IsRiskResult,
                    remark: ''
                  },
                  {
                    name: '银行卡',
                    result: this.encryption(res.data.order.Bankcard),
                    truth: element.IsRiskResult,
                    remark: ''
                  }
                ]
              } else if (element.ProductId == "f32ea4e6-195c-4e99-9b97-44347cd61b8c") {
                if (!that.isNull(element.ThirdPartyReturn3)) {
                  let thirddata = element.ThirdPartyReturn3.data
                  let thirddatares = thirddata.result
                  if (thirddatares && !that.isNull(thirddatares) && JSON.stringify(thirddatares) != '{}') {
                    that.educInfoData = [{
                        name: '学校名称',
                        result: thirddatares.SL ? thirddatares.SL : '',
                        resultType: 'SL',
                        truth: element.IsRiskResult,
                        remark: ''
                      },
                      {
                        name: '专业',
                        result: thirddatares.MJ ? thirddatares.MJ : '',
                        resultType: 'MJ',
                        truth: element.IsRiskResult,
                        remark: ''
                      },
                      {
                        name: '入学日期',
                        result: thirddatares.RD ? thirddatares.RD : '',
                        resultType: 'RD',
                        truth: element.IsRiskResult,
                        remark: ''
                      },
                      {
                        name: '毕业日期',
                        result: thirddatares.BD ? thirddatares.BD : '',
                        resultType: 'BD',
                        truth: element.IsRiskResult,
                        remark: ''
                      },
                      {
                        name: '985学校核验',
                        result: thirddatares.UCA == 1 ? '是' : '否',
                        resultType: 'UCA',
                        truth: element.IsRiskResult,
                        remark: ''
                      },
                      {
                        name: '211学校核验',
                        result: thirddatares.UCB == 1 ? '是' : '否',
                        resultType: 'UCB',
                        truth: element.IsRiskResult,
                        remark: ''
                      },
                      {
                        name: '双一流学校核验',
                        result: thirddatares.UCC == 1 ? '是' : '否',
                        resultType: 'UCC',
                        truth: element.IsRiskResult,
                        remark: ''
                      },
                      {
                        name: '学习形式',
                        result: !that.isNullEdu(thirddatares.FC) ? thirddatares.FC : '',
                        resultType: 'FC',
                        truth: element.IsRiskResult,
                        remark: ''
                      },
                      {
                        name: '学习层次',
                        result: !that.isNullEdu(thirddatares.LC) ? thirddatares.LC : '',
                        resultType: 'LC',
                        truth: element.IsRiskResult,
                        remark: ''
                      },
                      {
                        name: '毕业状态',
                        result: thirddatares.ST ? thirddatares.ST : '',
                        resultType: 'ST',
                        truth: element.IsRiskResult,
                        remark: ''
                      }
                    ]
                    // 排除掉为空的数据
                    that.educInfoData = that.educInfoData.filter(function (item, index, array) {
                      return !that.isNullEdu(item.result);
                    });
                  } else {
                    that.educInfoData = []
                  }
                } else {
                  that.educInfoData = []
                }
              } else if (element.ProductId == 'f32ea4e6-195c-4e99-9b97-44347cd61b4c') {
                if (!that.isNull(element.ThirdPartyReturn3)) {
                  let thirddata3 = element.ThirdPartyReturn3.DATA
                  if (thirddata3 && !that.isNull(thirddata3) && JSON.stringify(thirddata3) != '{}') {
                    that.overdueRiskData = [{
                        name: '最近一次逾期距今天数',
                        result: thirddata3.D942 && thirddata3.D942 != 'none' ? thirddata3.D942 : thirddata3.D942 == 'none' ? '0' : '',
                        resultType: 'D942'
                      },
                      {
                        name: '最大逾期天数距今天数',
                        result: thirddata3.D945 && thirddata3.D945 != 'none' ? thirddata3.D945 : thirddata3.D945 == 'none' ? '0' : '',
                        resultType: 'D945'
                      },
                      {
                        name: '逾期次数',
                        result: thirddata3.D177 && thirddata3.D177 != 'none' ? thirddata3.D177 : thirddata3.D177 == 'none' ? '0' : '',
                        resultType: 'D177'
                      },
                      {
                        name: '逾期机构数',
                        result: thirddata3.D939 && thirddata3.D939 != 'none' ? thirddata3.D939 : thirddata3.D939 == 'none' ? '0' : '',
                        resultType: 'D939'
                      },
                      {
                        name: '逾期总金额',
                        result: thirddata3.D181 && thirddata3.D181 != 'none' ? thirddata3.D181 : thirddata3.D181 == 'none' ? '0' : '',
                        resultType: 'D181'
                      },
                      {
                        name: '逾期最大金额',
                        result: thirddata3.D185 && thirddata3.D185 != 'none' ? thirddata3.D185 : thirddata3.D185 == 'none' ? '0' : '',
                        resultType: 'D185'
                      },
                      {
                        name: '最大一次逾期距今天数',
                        result: thirddata3.D940 && thirddata3.D940 != 'none' ? thirddata3.D940 : thirddata3.D940 == 'none' ? '0' : '',
                        resultType: 'D940'
                      },
                      {
                        name: '最近一次逾期金额',
                        result: thirddata3.D941 && thirddata3.D941 != 'none' ? thirddata3.D941 : thirddata3.D941 == 'none' ? '0' : '',
                        resultType: 'D941'
                      },
                      {
                        name: '最近一次逾期机构类型',
                        result: thirddata3.D943 && thirddata3.D943 != 'none' ? thirddata3.D943 : thirddata3.D943 == 'none' ? '0' : '',
                        resultType: 'D943'
                      },
                      {
                        name: '最大逾期天数',
                        result: thirddata3.D944 && thirddata3.D944 != 'none' ? thirddata3.D944 : thirddata3.D944 == 'none' ? '0' : '',
                        resultType: 'D944'
                      }
                    ]
                  } else {
                    that.overdueRiskData = []
                  }
                } else {
                  that.overdueRiskData = []
                }
              } else if (element.ProductId == 'f32ea4e6-195c-4e99-9b91-44347cd62b9c') {
                if (
                  !that.isNull(element.ThirdPartyReturnSet)
                ) {
                  const info1 = JSON.parse(element.ThirdPartyReturnSet)
                  console.log('info1', info1)
                  that.$set(element, 'returnSetList1', info1)
                }
                // console.log(JSON.parse(element.ThirdPartyReturnSet))
              } else if (element.ProductId == 'F32ea4e6-195c-4e99-9b97-44347cd61b0c') {
                if (
                  !that.isNull(element.ThirdPartyReturnSet)
                ) {
                  const info2 = JSON.parse(element.ThirdPartyReturnSet)
                  that.$set(element, 'returnSetList2', info2)
                }
                console.log(JSON.parse(element.ThirdPartyReturn))
              } else if (element.ProductId == 'f32ea4e6-195c-4e99-9b97-44347cd61b9c') {
                if (
                  element.ThirdPartyReturn != undefined &&
                  element.ThirdPartyReturn
                ) {
                  if (element.ThirdParty == '朴道') { //朴道
                    try {
                      let info = JSON.parse(element.ThirdPartyReturn);
                      let a = JSON.parse(info.data).ppre_execut;
                      let b = JSON.parse(info.data).ppre_case_flow;
                      let c = JSON.parse(info.data).ppre_judgment;
                      let d = JSON.parse(info.data).ppre_court_notice;
                      let e = JSON.parse(info.data).ppre_session;
                      let f = JSON.parse(info.data).ppre_exposure;
                      let g = JSON.parse(info.data).ppre_dishonesty;
                      if (!this.isNull(a)) {
                        that.judicialLitigation = a; // 执行公告维度
                      }
                      if (!this.isNull(b)) {
                        that.caseProcessData = b; // 案件流程维度
                      }
                      if (!this.isNull(c)) {
                        that.dimJudicialData = c; // 裁判文书维度
                      }
                      if (!this.isNull(d)) {
                        that.courtDimData = d; // 法院公告维度
                      }
                      if (!this.isNull(e)) {
                        that.openDimData = e; // 开庭公告维度
                      }
                      if (!this.isNull(f)) {
                        that.exposureTableData = f; // 曝光台
                      }
                      if (!this.isNull(g)) {
                        that.dishonestInfoData = g; // 失信信息
                      }
                    } catch (e) {
                      console.log(e)
                    }
                  } else if (element.ThirdParty == '华道') { //华道
                    try {
                      let a = JSON.parse(element.ThirdPartyReturn);
                      this.judicialLitigationHD = a.ALLLIST;
                    } catch (e) {
                      console.log(e)
                    }
                  }
                }
              } else if (element.ProductId == 'f32ea4e6-195c-4e99-9b92-44347cd62b9c') {
                try {
                  this.judicialLitigationHD2 = JSON.parse(element.ThirdPartyReturn);
                } catch (e) {
                  console.log(e)
                }
              } else if (element.ProductId == 'f32ea4e6-195c-4e99-9b97-44347cd62b9c') {
                if (
                  element.ThirdPartyReturn != undefined &&
                  element.ThirdPartyReturn
                ) {
                  const info = JSON.parse(element.ThirdPartyReturn)
                  if (!this.isNull(info.CourtDetailPro.entryList)) {
                    that.personalAdvanced = info.CourtDetailPro.entryList
                  }
                }
              } else if (element.ProductId == 'f32ea4e6-195c-4e99-9b97-44347cd61b1c') {
                if (
                  element.ThirdPartyReturnSet != undefined &&
                  element.ThirdPartyReturnSet
                ) {
                  this.creditRisks = JSON.parse(element.ThirdPartyReturnSet)
                }
              }
            })
            if (!that.isNull(that.litigationRisk)) { //判断司法诉讼是否存在有风险的
              let obj1 = that.litigationRisk.filter(item => item.IsRiskResult != '0');
              if (obj1 && !that.isNull(obj1)) {
                // 存在
                that.isHasRiskData = true
              } else {
                // 不存在
                that.isHasRiskData = false
              }
            }
            this.result = res.data
            this.hasResult = true
            if (type == 'export') { // 单个导出
              that.handleExport()
            } else if (type == 'batchExport') { // 批量导出
              that.handleBatchExport()
            }
            // console.log('sss',that.litigationRisk,that.isHasRiskData)
          } else {
            this.$message.error('结果获取失败，请从闪查记录页面查看结果！')
            this.result = {}
          }
        })
      },
      expRpt(Id) {
        const that = this
        this.getRptDetails(Id, 'export')
      },
      reportView(Id, InquiryAgency) {
        this.InquiryAgency = InquiryAgency
        this.getRptDetails(Id)
        this.visibleReport = true
      },
      isNull(o) {
        return (
          o == undefined ||
          o == 'undefined' ||
          (o + '').indexOf('undefined') > -1 ||
          o == null ||
          o == '' ||
          o == 'null' ||
          o == [] ||
          o == 'NaN' ||
          o == '[{}]'
        )
      },
      isNullEdu(o) {
        return (
          o == undefined ||
          o == 'undefined' ||
          (o + '').indexOf('undefined') > -1 ||
          o == null ||
          o === '' ||
          o == 'null' ||
          o === [] ||
          o == 'NaN'
        )
      },
      // 导出报告
      handleExport() {
        this.expvivw = true
        const name =
          '闪查报告-' + this.result.order.SurveyName + '-' + this.result.order.Id
        setTimeout(() => {
          let lableList1 = document.getElementsByClassName('small_item');
          let logo = document.getElementById("logo"); //放在页眉的图标
          downloadPDF(name, document.querySelector('#pdf_details'), lableList1, logo);
        }, 100)
        setTimeout(() => {
          this.expvivw = false;
        }, 400)
      },
      // 批量导出操作
      handleBatchExport() {
        this.expvivw = true
        const name =
          '闪查报告-' + this.result.order.SurveyName + '-' + this.result.order.Id;
        let lableList1, logo
        setTimeout(() => {
          lableList1 = document.getElementsByClassName('small_item');
          logo = document.getElementById("logo"); //放在页眉的图标
          downloadPDF(name, document.querySelector('#pdf_details'), lableList1, logo, 'batchExport', (res) => {
            this.fileArr.push(res)
            // console.log('dd', res, this.fileArr)
            if (this.fileArr.length == this.multipleTable.length) {
              this.filesToRar()
            }
          })
        }, 150)
        setTimeout(() => {
          this.expvivw = false
        }, 1000)
      },
      // 批量导出
      batchExport() {
        if (this.multipleTable.length == 0) {
          this.$message.warning('请至少选择一份报告导出')
        } else if (this.multipleTable.length > 10) {
          this.$message.warning('最多选择十份报告导出')
        } else {
          const r = this.multipleTable.some(ele => ele.Progress != 2)
          if (r) {
            this.$message.warning('请选择已完成的报告导出')
          } else {
            this.expLoading = true
            let index = 0
            this.interval = setInterval(() => {
              this.getRptDetails(this.multipleTable[index].Id, 'batchExport')
              if (index + 1 == this.multipleTable.length) {
                // this.expLoading = false;
                clearInterval(this.interval)
              }
              index++
            }, 2000)
          }
        }
      },
      // 时间戳转日期时间
      getDate(val) {
        if (val) {
          const date = new Date(val); // 根据时间戳创建Date对象
          const year = date.getFullYear(); // 获取年份
          const month = date.getMonth() + 1; // 获取月份，需要加1
          const day = date.getDate(); // 获取日期
          const formattedDate = `${year}-${month}-${day}`; // 拼接成格式化后的日期字符串
          console.log(formattedDate);
          return formattedDate;
        } else {
          return "";
        }
      },
      // 把多个文件打包
      filesToRar() {
        const that = this
        // console.log('aa', that.fileArr)
        const zip = new JSZip() // 创建实例对象
        const promises = []
        that.fileArr.forEach((item, index) => {
          const promise = that.getFile(item).then(res => {
            const fileName = '闪查报告-' + this.multipleTable[index].SurveyName + '-' + this.multipleTable[index].OrderId + '.pdf'
            // 创建文件用file()，创建文件夹用 floder()
            zip.file(fileName, res, {
              binary: true
            })
          })
          promises.push(promise)
        })
        /**
          	Promise.all 方法用于将多个 Promise 实例，包装成一个新的 Promise 实例,
          	只有当all([p1, p2, p3]) 中的每一个 Promise 实例的状态都变成 fulfilled, Promise.all()的状态才会变成 fulfilled，此时  p1, p2, p3 的返回值组成一个数据，传给 Promise.all()的回调函数
          	只要 p1, p2, p3 中任何一个被 rejected,  Promise.all() 的状态就会变成 rejected，此时第一个被 rejected 的实例的返回值，会传给 Promise.all()的回调函数。
          	在上面的代码中，promises 数组中的每一个元素，都是 Promise 实例，所以需要用到 Promise.all()
          */
        // 生成 zip 文件
        Promise.all(promises).then(() => {
          that.expLoading = false
          that.$message.success('文件生成成功！')
          // 生成zip 文件
          zip.generateAsync({
            type: 'blob',
            compression: 'DEFLATE', // STORE: 默认不压缩， DEFLATE：需要压缩
            compressionOptions: {
              level: 9 // 压缩等级 1~9   1 压缩速度最快， 9 最优压缩方式
            }
          }).then((res) => {
            const name = '批量查询报告' + new Date().valueOf().toString() + '.zip'
            FileSaver.saveAs(res, name) // 使用FileSaver.saveAs保存文件，文件名可自定义
          })
        })
      },
      getFile(file) {
        return new Promise((resolve, reject) => {
          resolve(file)
        })
      },
      handleClick(tab, event) {
        let that = this
        this.activeName = tab.name;
        if (tab.name == "second") {
          that.$router.push({
            path: '/bgSet',
            query: {
              activeName: 'second'
            }
          })
        } else if (tab.name == "first") {
          that.$router.push({
            path: '/bgSet',
            query: {
              activeName: 'first'
            }
          })
        } else if (tab.name == "third") {
          that.$router.push({
            path: '/bgSet',
            query: {
              activeName: 'third'
            }
          })
        } else if (tab.name == "four") {
          that.$router.push({
            path: '/consumerDetails',
            query: {
              activeName: 'four'
            }
          })
        } else if (tab.name == "five") {
          that.getcertorderlist()
        } else if (tab.name == "six") {
          that.$router.push({
            path: '/bgSet',
            query: {
              activeName: 'six'
            }
          })
        }
      }
    }
  };
</script>
<style scoped>
  .bgset_btn {
    display: flex;
    justify-content: flex-end;
    padding: 0 16px;
  }

  .lh20 {
    line-height: 20px;
    margin: 0;
  }

  #logo {
    display: none;
    width: 175px;
    height: 57px;
  }

  .bg_des_box {
    display: flex;
    align-items: center;
    border: 1px solid #dfe6ec;
    border-bottom: none;
    font-size: 14px;
    color: #333;
    background-color: rgb(221, 221, 221, .7);
  }

  .bg_des_left {
    width: 180px;
    text-align: left;
    padding: 10px 0;
    /* // color:#606266; */
    box-sizing: border-box;
  }

  .bg_des_right {
    flex: 1;
    text-align: left;
    padding: 10px;
    line-height: 20px;
    box-sizing: border-box;
    border-left: 1px solid #ddd;
  }

  .pic_txt {
    margin: 0;
    line-height: 20px;
  }

  .bg_result_box {
    width: 1001px;
  }

  .bg_result_box.bg_result_box00 {
    width: auto;
  }

  .bg_result_box00 .bg_result_item {
    width: 100%;
    box-sizing: border-box;
  }

  .bg_result_item {
    color: #606266;
    background-color: #FFFFFF;
    font-size: 14px;
    border-collapse: collapse;
    display: table;
  }

  .bg_result_left {
    font-weight: 500;
    color: #000;
    width: 181px;
    text-align: left;
  }

  .bg_result_right {
    width: 820px;
    text-align: left;
  }

  .bg_result_cell {
    display: table-cell;
    border: 1px solid #e6ebf5;
    padding: 10px;
    box-sizing: border-box;
    border-collapse: collapse;
    line-height: 1.5;
  }

  .bg_result_item02 .bg_result_cell {
    border-top: none;
  }

  .category_title {
    width: 1001px;
    color: #606266;
    text-align: left;
    padding-left: 10px;
    background: rgb(25, 189, 146, .4);
    height: 36px;
    line-height: 36px;
    font-size: 16px;
    box-sizing: border-box;
  }

  .category_title00.category_title {
    width: auto;
  }

  .bg_widthauto.bg_result_right {
    width: calc(100% - 181px);
  }

  .mb24 {
    margin-bottom: 24px;
  }

  .w1000 {
    width: 1000px;
    box-sizing: border-box;
  }

  .w1000_des {
    width: 1000px;
    padding: 15px 15px 0px 15px;
    box-sizing: border-box;
  }

  .c_border {
    border: 1px solid #dfe6ec;
    padding: 12px 10px;
  }

  .note_danger_txt {
    color: #000000a6;
    font-size: 14px;
  }

  .res_icon_right {
    font-size: 24px;
    color: #19bd92;
  }

  .res_icon_error {
    font-size: 24px;
    color: #F56C6C;
  }

  .title_note_box {
    color: #666;
    font-size: 14px;
    margin-bottom: 8px;
  }

  .result_report_box {
    width: 1001px;
    background: #fff;
    /* opacity: 0; */
  }

  .result_report {
    width: 1001px;
    padding: 10px 100px 30px;
    margin: 0 auto;
    position: relative;
  }

  .logo img {
    width: 175px;
    margin-top: 20px;
  }

  .resultTitle {
    height: 36px;
    line-height: 36px;
    font-size: 15px;
    font-weight: 600;
    margin: 24px 0;
    width: 1000px;
  }

  .tableTitle {
    width: 1001px;
    color: #fff;
    background: #19bd92;
    text-align: center;
    height: 43px;
    line-height: 43px;
    font-size: 16px;
  }

  .tips p {
    font-size: 13px;
    line-height: 20px;
  }

  .block {
    background-color: #fff;
    text-align: right;
    padding: 10px 10px 10px;
  }

  .flname {
    min-width: 40px;
    width: 66px;
    padding-right: 8px;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .proName {
    font-weight: 700;
    font-size: 14px;
    margin-left: 15px;
  }

  .p_allcustom_content {
    min-height: calc(100vh - 84px);
    background: #f3f3f3;
    /* padding: 12px 16px; */
  }

  .topOperation {
    height: 56px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    width: 100%;
    background-color: #ffffff;
  }

  .top-left {
    display: -webkit-box;
    display: -ms-flexbox;
    flex: 1;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    margin-top: 10px;
  }

  .screenInputs {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    /* flex-wrap: wrap; */
  }

  .screenInput {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: 0 0 10px 15px;
    font-size: 14px;
    color: #606266;
  }

  .flname {
    min-width: 40px;
    width: 68px;
    padding-right: 8px;
    font-size: 14px;
    text-align: right;
  }

  .drop-footer {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    padding: 0 30px 20px 0;
  }

  .rpTirle {
    font-size: 48px;
    text-align: center;
    width: 100%;
    font-weight: bold;
  }

  .rpContent {
    text-align: center;
    width: 100%;
    margin: 24px 0;
    font-size: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dot {
    border-radius: 100%;
    background: #19bd92;
  }

  .dot1 {
    width: 8px;
    height: 8px;
  }

  .dot2 {
    width: 12px;
    height: 12px;
    margin: 0 8px;
  }

  .dot3 {
    width: 16px;
    height: 16px;
  }

  .statement {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 18px;
  }

  .statementContent {
    text-indent: 2em;
    line-height: 32px;
    font-size: 16px;
  }

  .cover {
    height: 1730px;
    width: 1000px;
    position: relative;
    background: #fff;
  }

  .coverLeft {
    position: absolute;
    left: 0;
    top: 0;
  }

  .coverRight {
    position: absolute;
    right: 0;
    bottom: 0;
    height: 674px;
  }

  .p_cusDtl_table {
    background-color: #fff;
  }

  .p_allcustom_content .screenInput {
    margin-left: 0px;
  }

  .i_txt {
    cursor: pointer;
    margin-left: 3px;
  }

  .top-right {
    width: 70px;
  }

  .small_item {
    width: 1001px;
  }
</style>
<style>
  .p_allcustom_content .el-descriptions-item__label.is-bordered-label {
    color: #000;
    width: 180px;
    line-height: 20px !important;
  }

  .p_allcustom_content .el-descriptions-item__content {
    width: 320px !important;
    line-height: 20px !important;
  }

  .p_allcustom_content .screenInput .el-date-editor.el-input__inner {
    width: 230px !important;
  }

  .p_allcustom_content .el-select {
    width: 200px;
  }

  .p_allcustom_content .screenInput .el-input {
    width: 200px;
    margin-left: 0;
  }

  .p_cusDtl_table .el-tabs {
    background: #fff;
    padding: 10px 16px 16px;
  }

  .re_down_form1 .el-form-item {
    margin-bottom: 10px;
  }

  .p_allcustom_content .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 230px !important;
    height: 32px;
    line-height: 32px;
  }

  .checktime .el-date-editor .el-range__icon {
    height: 32px !important;
  }

  .personalAdvanced .el-descriptions-item__label.is-bordered-label {
    color: #000;
    width: 180px;
    line-height: 20px !important;
  }

  .personalAdvanced .el-descriptions-item__content {
    width: 320px !important;
    line-height: 20px !important;
  }

  .p_allcustom_content .el-input__icon {
    height: 32px;
  }
</style>